import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-copy",
  templateUrl: "./med-icon-copy.component.html",
})
export class MedIconCopyComponent extends SvgMixinComponent {}
